// extracted by mini-css-extract-plugin
export default {"wrapper":"TournamentsMenu_wrapper--u_I","item":"TournamentsMenu_item--FDs","active":"TournamentsMenu_active--vDh","activeItemText":"TournamentsMenu_activeItemText--FUw"};